<!--SUPPLIER CREDIT NOTE ITEM-->
<div
  class="grid template-cols-36 supplier-credit-note-item"
  [ngClass]="supplierCreditNoteItem().doNotCredit ? 'fc-neutral-600' : ''">
  <div class="g-col-1 k-d-flex k-align-items-center" style="width: 32px;">
    <kendo-dropdownbutton
      class="no-bg-dropdown"
      iconClass="rc-icon-vertical-dots"
      [hidden]="supplierCreditNoteIsLocked()"
      [data]="menuItems()"
      (itemClick)="onActionMenuItemClick($event)">
    </kendo-dropdownbutton>
  </div>

  <div class="g-col-6 k-d-flex k-align-items-center">
    <div class="d-flex flex-column gap-8">
      <div
        class="fw-500 h-unset"
        [rcCopyOnClick]="supplierCreditNoteItem().articleNumber"
        [rcNavigate]="supplierCreditNoteItem().supplierArticle">
        {{ supplierCreditNoteItem().articleNumber }}
        @if (itemIsDoNotCredit()) { <i class="rc-icon-no-invoice ps-8"></i> }
      </div>
      <div>{{ supplierCreditNoteItem().reference }}</div>
    </div>
  </div>

  <div class="g-col-5 k-d-flex k-align-items-center" #wrapper>
    <span rcSelectableOverflow [wrapperElement]="wrapper" [rowAmount]="3" >{{ supplierCreditNoteItem().description }}</span>
  </div>

  <div class="g-col-2 k-d-flex k-align-items-center k-justify-content-end">
    {{ supplierCreditNoteItem().amount | kendoNumber: amountFormat }}
  </div>

  <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
    {{ supplierCreditNoteItem().retailPrice | kendoNumber: decimalFormat }}
  </div>

  <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
    {{ supplierCreditNoteItem().taxPrice | kendoNumber: decimalFormat }}
  </div>

  <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
    {{ supplierCreditNoteItem().basicNetPrice | kendoNumber: decimalFormat }}
  </div>

  <div class="g-col-4 k-d-flex k-align-items-center">
    {{ supplierCreditNoteItem().conditionString }}
  </div>

  <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
    {{ supplierCreditNoteItem().purchasePrice | kendoNumber: decimalFormat }}
  </div>

  <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
    {{ supplierCreditNoteItem().lineTotal | kendoNumber: decimalFormat }}
  </div>
</div>

<!--SUPPLIER CREDIT NOTE ITEM MAPPINGS-->
@let mappings = supplierCreditNoteItemMappings();
<div [ngClass]="mappings.length > 0 && !supplierCreditNoteIsLocked() ? 'supplier-credit-note-item-mappings' : ''">
  @for (mapping of mappings; track mapping['@id']) {
    <div class="grid template-cols-36 supplier-credit-note-item-mapping-row k-mt-4">
      <div class="g-col-1"></div>

      <div class="g-col-35 d-flex align-items-center border rounded-1">
        <button
          kendoButton
          [type]="'button'"
          class="bg-neutral-100"
          iconClass="rc-icon-link fs-16"
          [hidden]="supplierCreditNoteIsLocked()"
          [disabled]="itemIsDoNotCredit()"
          (click)="linkItemToExistingMapping(mapping)">
          <span class="fw-500">{{ "LINK" | translate | capitalize }}</span>
        </button>

        @if (mapping.client) {
          <div class="g-col-5 d-flex align-items-center gap-8 ps-16">
            <button
              kendoButton
              [type]="'button'"
              class="link-button"
              iconClass="rc-icon-store fc-neutral-600"
              (click)="navigateToClient(mapping.client)">
              {{ mapping.clientName | uppercase }}
            </button>
          </div>
        }

        @let linkTypes = getLinkTypes(mapping);
        @let documentLink = linkTypes?.documentLink;
        @let itemLink = linkTypes?.itemLink;
        @if (documentLink) {
          <div class="g-col-5 d-flex align-items-center gap-8">
            <button
              kendoButton
              [type]="'button'"
              class="link-button"
              [iconClass]="documentLink.icon + ' fc-neutral-600'"
              (click)="openLinkModal(documentLink.type, mapping)">
              1 {{ documentLink.label | translate }}
            </button>
          </div>
        }
        @if (itemLink) {
          <div class="g-col-5 d-flex align-items-center gap-8">
            <button
              kendoButton
              [type]="'button'"
              class="link-button"
              [iconClass]="itemLink.icon + ' fc-neutral-600'"
              (click)="openLinkModal(itemLink.type, mapping)">
              1 {{ itemLink.label | translate }}
            </button>
          </div>
        }
      </div>
    </div>

    <!--CLIENT CREDIT NOTE DRAFT ITEM-->
    @let draftItem = getDraftItemForMapping(mapping);
    @if (draftItem) {
      @let draftItemForm = draftItemForms.get(draftItem['@id']!);
      @if (draftItemForm) {
        <form [formGroup]="draftItemForm" class="grid template-cols-36 k-my-4">
          <div class="g-col-1"></div>
          <div class="g-col-6">
            <kendo-formfield showHints="initial" showErrors="initial">
              @let articles = articlesByDraftItem$.get(draftItem['@id']!) | async;
              <kendo-combobox
                rcValidation
                formControlName="articleNumber"
                [data]="articles ?? []"
                [filterable]="true"
                [kendoDropDownFilter]="filterSettings"
                (filterChange)="onSearchArticles($event, draftItem)"
                [valuePrimitive]="true"
                [textField]="'number'"
                [valueField]="'number'"
                (blur)="onDraftItemFormBlur(draftItem, 'articleNumber')"
              ></kendo-combobox>
            </kendo-formfield>
          </div>
          <div class="g-col-5">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-textbox
                rcValidation
                formControlName="reference"
                (blur)="onDraftItemFormBlur(draftItem, 'reference')"
              ></kendo-textbox>
            </kendo-formfield>
          </div>
          <div class="g-col-2">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-numerictextbox
                [spinners]="false"
                [changeValueOnScroll]="false"
                [format]="amountFormat"
                [decimals]="amountDecimals"
                rcValidation
                formControlName="amount"
                (blur)="onDraftItemFormBlur(draftItem, 'amount')"
              ></kendo-numerictextbox>
            </kendo-formfield>
          </div>
          <div class="g-col-4"></div>
          <div class="g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-numerictextbox
                [format]="decimalFormat"
                [spinners]="false"
                [changeValueOnScroll]="false"
                [decimals]="2"
                rcValidation
                formControlName="taxPrice"
                (blur)="onDraftItemFormBlur(draftItem, 'taxPrice')"
              ></kendo-numerictextbox>
            </kendo-formfield>
          </div>
          <div class="g-col-3">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-numerictextbox
                [format]="decimalFormat"
                [spinners]="false"
                [changeValueOnScroll]="false"
                [decimals]="2"
                rcValidation
                formControlName="basicNetPrice"
                (blur)="onDraftItemFormBlur(draftItem, 'basicNetPrice')"
              ></kendo-numerictextbox>
            </kendo-formfield>
          </div>
          <div class="g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-textbox
                rcValidation
                formControlName="conditionString"
                (blur)="onDraftItemFormBlur(draftItem, 'conditionString')"
              ></kendo-textbox>
            </kendo-formfield>
          </div>
          <div class="g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-numerictextbox
                [format]="decimalFormat"
                [spinners]="false"
                [changeValueOnScroll]="false"
                [decimals]="2"
                rcValidation
                formControlName="purchasePrice"
                (blur)="onDraftItemFormBlur(draftItem, 'purchasePrice')"
              ></kendo-numerictextbox>
            </kendo-formfield>
          </div>
          <div class="g-col-2 d-flex align-items-center justify-content-end">
            <button
              class="bg-transparent border-0 p-0"
              (click)="openItemMappingDeleteDialog(mapping)"
              (keydown.enter)="openItemMappingDeleteDialog(mapping)"
              [style.pointer-events]="itemLocked() ? 'none' : 'auto'"
              [hidden]="supplierCreditNoteIsLocked()"
              [disabled]="itemLocked()">
              <i class="rc-icon-trash fs-24 fc-neutral-700"></i>
            </button>
          </div>
        </form>
      }
    }

    <!--CLIENT CREDIT NOTE ITEM-->
    @let linkedItem = getLinkedItemForMapping(mapping);
    @if (linkedItem) {
      <div class="grid template-cols-36 client-credit-note-item">
        <div class="g-col-1 k-d-flex k-align-items-center"></div>

        <div class="g-col-6 k-d-flex k-align-items-center">
          <div class="d-flex flex-column gap-8">
            <div [rcCopyOnClick]="linkedItem.articleNumber" [rcNavigate]="linkedItem.supplierArticle">{{ linkedItem.articleNumber }}</div>
            <div>{{ linkedItem.reference }}</div>
          </div>
        </div>

        <div class="g-col-5 k-d-flex k-align-items-center">
          {{ linkedItem.description }}
        </div>

        <div class="g-col-2 k-d-flex k-align-items-center k-justify-content-end">
          {{ linkedItem.amount | kendoNumber: amountFormat }}
        </div>

        <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
          {{ linkedItem.retailPrice | kendoNumber: decimalFormat }}
        </div>

        <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
          {{ linkedItem.taxPrice | kendoNumber: decimalFormat }}
        </div>

        <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
          {{ linkedItem.basicNetPrice | kendoNumber: decimalFormat }}
        </div>

        <div class="g-col-4 k-d-flex k-align-items-center">
          {{ linkedItem.conditionString }}
        </div>

        <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
          {{ linkedItem.purchasePrice | kendoNumber: decimalFormat }}
        </div>

        <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
          {{ linkedItem.lineTotal | kendoNumber: decimalFormat }}
        </div>
      </div>
    }
  }
</div>

<div class="d-flex justify-content-end" [hidden]="supplierCreditNoteIsLocked()">
  <button kendoButton [type]="'button'" class="link-button" iconClass="rc-icon-link" (click)="createNewMapping()">
    {{ "LINK" | translate | capitalize }}
  </button>
  <button kendoButton [type]="'button'" class="link-button" iconClass="rc-icon-plus" [hidden]="itemIsDoNotCredit()" (click)="openLinkClientDialog()">
    {{ "ADD_ENTITY" | translate: { entity: ("LINE" | translate) } | capitalize }}
  </button>
</div>

<rc-table-modal [tableConfig]="tableConfig" (closeEvent)="close()" />
